import { it } from "../../../../date-fns/locale/it.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    it
  }
};